import { FieldInput } from 'components/fieldInput';
import { Form, Formik } from 'formik';
import React, { Fragment } from 'react';
import CustomLoader from 'components/CustomLoader';
import { EndorsementsTable } from '../components/EndorsementsTable';
import styles from '../styles.module.scss';

export function AdditionalInterest({
  validation,
  endorsements,
  changes,
  loading,
  setEndorsements,
  setStage,
  submit,
  submitting,
  resetModal
}) {
  return (
    <div className={styles.insideWrapper}>
      <div className={styles.title}>
        Add an Additional Interest
      </div>
      <div className={styles.line} />
      <Formik
        validationSchema={validation}
        initialValues={{
          name_of_interest: '',
          address_of_interest: '',
          special_instructions: '',
        }}
      >
        {({
          errors,
          touched,
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          validateForm,
          setTouched,
        }) => (
          <Fragment>
            <Form
              className={styles.form}
              onSubmit={handleSubmit}
              style={{ marginTop: 10 }}
            >
              <div className={styles.fieldRow} style={{ marginBottom: 10 }}>
                <FieldInput
                  id="name_of_interest"
                  type="text"
                  label="Name of Interest"
                  placeholder="Name of Interest"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.name_of_interest}
                  touched={touched.name_of_interest}
                  required
                  fullWidth
                />
              </div>
              <div className={styles.fieldRow} style={{ marginBottom: 10 }}>
                <FieldInput
                  id="address_of_interest"
                  type="text"
                  label="Address of Interest"
                  placeholder="Address of Interest"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.address_of_interest}
                  touched={touched.address_of_interest}
                  required
                  fullWidth
                />
              </div>
              <div className={styles.fieldRow} style={{ marginBottom: 10 }}>
                <FieldInput
                  id="special_instructions"
                  type="text"
                  label="Special Instructions"
                  placeholder="Special Instructions"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.special_instructions}
                  touched={touched.special_instructions}
                  required
                  fullWidth
                />
              </div>
            </Form>
            {endorsements.length > 0 && (
              <EndorsementsTable changes={changes} loading={loading} />
            )}
            <div
              className={styles.footer}
              style={{
                justifyContent: 'space-between',
              }}
            >
              <div className={styles.buttons}>
                <button
                  className={styles.cancel}
                  onClick={resetModal}
                >
                  Cancel
                </button>
              </div>
              <div className={styles.buttons}>
                <button
                  className={styles.save}
                  style={{
                    marginRight: 10,
                    marginLeft: 10,
                    width: '240px',
                  }}
                  onClick={async () => {
                    const hasEnteredData = values.name_of_interest ||
                      values.address_of_interest ||
                      values.special_instructions;

                    if (hasEnteredData) {
                      setTouched({
                        name_of_interest: true,
                        address_of_interest: true,
                        special_instructions: true,
                      });

                      const validation = await validateForm(values);

                      if (Object.values(validation).length === 0) {
                        setEndorsements((prev) => [
                          ...prev,
                          {
                            type: 'additional_interest',
                            value: values,
                          },
                        ]);
                        setStage('select_endorsement_type');
                      }
                    } else {
                      setStage('select_endorsement_type');
                    }
                  }}
                >
                  Add Another Change
                </button>
                <button
                  className={styles.save}
                  style={{ width: '330px' }}
                  onClick={async () => {
                    setTouched({
                      name_of_interest: true,
                      address_of_interest: true,
                      special_instructions: true,
                    });

                    const validation = await validateForm(values);

                    if (Object.values(validation).length === 0) {
                      submit([
                        ...endorsements,
                        {
                          type: 'additional_interest',
                          value: values,
                        },
                      ]);
                    }
                  }}
                >
                  {submitting ? (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    'Finish and Submit Endorsement'
                  )}
                </button>
              </div>
            </div>
          </Fragment>
        )}
      </Formik>
    </div>
  );
}
